import {
  Card,
  CardContent,
  Container,
  Stack,
  Text,
} from "@generalapplications/ui";

import { IndustryGroup } from "./IndustryGroup";
import { SectionHeader } from "@/app/common/components/composite/layout/SectionHeader";
import { Reveal } from "@/app/common/components/composite/motion/Reveal";
import { homePage } from "@/content/home";
import { formatText } from "@/app/common/functions/format/formatText";

/** Where the work has been done, and where it is being developed. */
export function Industries() {
  const coreIndustries = homePage.industries.links.filter(
    (item) => item.slug !== "agriculture",
  );
  const developingIndustries = homePage.industries.links.filter(
    (item) => item.slug === "agriculture",
  );
  const [statement, ...asides] = homePage.industries.copy;

  return (
    <Card variant="soft" radius="xxl" padding="xl">
      <CardContent gap="xl">
        <Reveal>
          <Stack gap="lg">
            <SectionHeader title={homePage.industries.headline} />
            <Container width="lg" align="start">
              <Stack gap="md">
                {statement && (
                  <Text variant="prose">{formatText(statement)}</Text>
                )}
                {asides.map((paragraph) => (
                  <Text key={paragraph}>{formatText(paragraph)}</Text>
                ))}
              </Stack>
            </Container>
          </Stack>
        </Reveal>
        <IndustryGroup label="Experience" industries={coreIndustries} />
        <IndustryGroup
          label="Developing application area"
          industries={developingIndustries}
        />
      </CardContent>
    </Card>
  );
}
